/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trackNumber: NonNullable<unknown>, type: NonNullable<unknown> }} Track_Label_Type_Aria_LabelInputs */

const en_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.trackNumber} type: ${i?.type}`)
};

const fr_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piste ${i?.trackNumber} type: ${i?.type}`)
};

const de_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.trackNumber} Typ: ${i?.type}`)
};

const it_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo di traccia ${i?.trackNumber}: ${i?.type}`)
};

const ru_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Тип трека ${i?.trackNumber}: ${i?.type}`)
};

const es_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pista ${i?.trackNumber} tipo: ${i?.type}`)
};

const zh_cn2_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`轨道 ${i?.trackNumber} 类型：${i?.type}`)
};

const ja_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トラック ${i?.trackNumber} タイプ: ${i?.type}`)
};

const hi_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रैक ${i?.trackNumber} प्रकार: ${i?.type}`)
};

const pt_pt2_track_label_type_aria_label = /** @type {(inputs: Track_Label_Type_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faixa ${i?.trackNumber} tipo: ${i?.type}`)
};

/**
* | output |
* | --- |
* | "Track {trackNumber} type: {type}" |
*
* @param {Track_Label_Type_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const track_label_type_aria_label = /** @type {((inputs: Track_Label_Type_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Label_Type_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_track_label_type_aria_label(inputs)
	if (locale === "de") return de_track_label_type_aria_label(inputs)
	if (locale === "it") return it_track_label_type_aria_label(inputs)
	if (locale === "ru") return ru_track_label_type_aria_label(inputs)
	if (locale === "es") return es_track_label_type_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_track_label_type_aria_label(inputs)
	if (locale === "ja") return ja_track_label_type_aria_label(inputs)
	if (locale === "hi") return hi_track_label_type_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_track_label_type_aria_label(inputs)
	return en_track_label_type_aria_label(inputs)
});